// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"60f84c69","223":"c3eaaee6","239":"f891b4f0","453":"b94b5278","553":"6a6ca0ba"}[chunkId] + ".chunk.js";
};